import { Line } from "react-chartjs-2";
import { Box, useTheme } from "@mui/material";
import { getXAxisUnit, GraphColors } from "./helper";

export const LineChart = ({
  sx,
  // data = dummyData,
  labels = [],
  values = [],
  isMultipleDataSets = false,
  color = "random",
  options = {},
  alignment = "x",
  borderSkipped = undefined,
  customDataSet,
  xLabel = "",
  yLabel = "",
  unit = "",
  startDate = null,
  endDate = null,
  customTooltip = null,
  showLegend = false,
}) => {
  const xAxisUnit = getXAxisUnit(startDate, endDate);
  const { palette } = useTheme();
  const opt = {
    indexAxis: alignment,
    elements: {
      line: {
        // fill: {
        //   target: "origin",
        //   above: "red", // Area will be red above the origin
        //   // below: "yellow", // And blue below the origin
        // },
      },
    },
    // interaction: {
    //   intersect: false,
    //   mode: "index",
    // },
    maintainAspectRatio: false,
    responsive: true,
    interaction: {
      intersect: false,
      mode: "index",
    },
    plugins: {
      legend: {
        display: showLegend,
        position: "top",
        align: "end",
        labels: {
          color: palette.text?.primary || "#1a1a1a",
          font: {
            family: "Roboto",
            size: 15,
            weight: "500",
          },
          usePointStyle: true,
          pointStyle: "circle",
          padding: 10,
          boxWidth: 14,
          boxHeight: 8,
        },
      },
      tooltip: {
        position: "nearest",
        bodySpacing: 10,
        callbacks: customTooltip
          ? customTooltip({ values })
          : {
              label: ({ dataIndex, dataset }) => {
                let label = dataset.label || "";
                return `   ${label} : ${dataset.data[dataIndex]}`;
              },
            },
        // padding: 20,
      },
      // title: {
      //   display: true,
      //   text: "Chart.js Horizontal Bar Chart",
      // },
    },
    scales: {
      x: {
        type: "time",
        time: {
          unit: xAxisUnit || "week",
          tooltipFormat:
            xAxisUnit === "minute" ? "dd MMM, yyyy HH:mm" : "MMM dd, yyyy",
          displayFormats: {
            quarter: "MMM yyyy",
            month: "MMM yyyy",
            week: "dd MMM",
            day: "eeee",
            hour: "HH:mm",
            minute: "HH:mm",
          },
          // time: {
          //   unit: mappedData.xAxisUnit,
          //   tooltipFormat:
          //     mappedData.xAxisUnit === "minute"
          //       ? "MMM dd, yyyy HH:mm"
          //       : "MMM dd, yyyy",
          //   displayFormats: {
          //     quarter: "MMM yyyy",
          //     month: "MMM yyyy",
          //     week: "MMM dd",
          //     day: "eeee",
          //     hour: "HH:mm",
          //     minute: "HH:mm",},
        },
        beginAtZero: true,
        grid: {
          display: false,
          tick: false,
        },
        title: {
          display: !!xLabel,
          text: xLabel,
          color: palette.custom.sub_heading,
          font: {
            family: "Roboto",
            size: 17,
            weight: "400",
            lineHeight: 1.2,
          },
          padding: { top: 20 },
        },
        ticks: {
          color: palette.custom.sub_heading,
          font: {
            family: "Roboto",
            size: 12,
            weight: "500",
          },
          maxRotation: 45,
          minRotation: 0,
          autoSkip: true,
          maxTicksLimit: 12,
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          display: true,
          tick: false,
        },
        title: {
          display: !!yLabel,
          text: yLabel,
          color: palette.custom.sub_heading,
          font: {
            family: "Roboto",
            size: 17,
            weight: "400",
            lineHeight: 1.2,
          },
          padding: { bottom: 20 },
        },
        ticks: {
          color: palette.custom.sub_heading,
          font: {
            family: "Roboto",
            size: 14,
            weight: "500",
          },
          // stepSize: 1,
          precision: 0,
          callback: (val = "") => {
            return `${val}${unit || ""}`;
          },
        },
      },
    },
    ...options,
  };

  const generateData = () => {
    if (isMultipleDataSets) {
      return {
        labels: labels.length ? labels : [startDate, endDate],
        datasets: values.map((v, index) => {
          return {
            fill: false,
            data: v.values.map((v) => (Array.isArray(v) ? v[0] : v)),
            label: v.label,
            backgroundColor: v.color,
            borderColor: v.color,
            borderWidth: 2,
            pointBorderWidth: 3,
            tension: 0.1,
          };
        }),
      };
    } else {
      return {
        labels,
        datasets: [
          {
            // fill: true,
            fill: {
              target: "origin",
              above: (context) => {
                const ctx = context.chart.ctx;
                const gradient = ctx.createLinearGradient(0, 0, 0, 400);
                gradient.addColorStop(0, `${color}aa`);
                gradient.addColorStop(1, "rgba(255,255,255,0)");
                return gradient;
              },
              // `linear-gradient(180deg, ${"red"} 13%, rgba(255,255,255,0) 100%)`,
            },
            // fillColor: "red",
            data: values,
            label: yLabel,
            borderColor: color !== "random" ? color : GraphColors[0],
            borderWidth: 2,
            pointBorderWidth: 3,
            borderSkipped: borderSkipped,
            backgroundColor: color !== "random" ? color : GraphColors[0],
            tension: 0.1,
            // point: {
            //   backgroundColor: "red",
            // },
          },
        ],
      };
    }
  };

  return (
    <Box sx={{ width: "100%", ...sx }}>
      <Line
        id="canvas"
        // datasetIdKey="id"
        data={customDataSet ? customDataSet : generateData()}
        options={opt}
      />
    </Box>
  );
};
